import { css } from '@linaria/atomic';
import { useTranslation } from '@frontend/i18n';
import { Icon } from '@frontend/icons';
import { NakedButton, Text } from '@frontend/design-system';

type EmptyOutboundStateProps = {
  onBack?: () => void;
  showBackButton: boolean;
};

export const EmptyOutboundState = ({ onBack, showBackButton }: EmptyOutboundStateProps) => {
  const { t } = useTranslation('inbox');

  return (
    <div className={containerStyles}>
      {showBackButton && onBack && (
        <NakedButton className={backButtonStyles} onClick={onBack} trackingId='empty-outbound-state-back-button'>
          <Icon name='back' size={16} />
        </NakedButton>
      )}
      <div className={contentStyles}>
        <Icon name='warning-badge' size={24} color='subdued' />
        <Text size='medium' color='subdued' textAlign='center'>
          {t('No outbound SMS numbers available')}
        </Text>
      </div>
    </div>
  );
};

const containerStyles = css`
  display: flex;
  flex-direction: column;
  padding: var(--fabric-space-padding-md);
  min-height: 80px;
`;

const backButtonStyles = css`
  display: flex;
  align-items: center;
  padding: var(--fabric-space-padding-xxs);
  margin-bottom: var(--fabric-space-gap-xs);
  color: var(--fabric-color-neutral-70);

  &:hover {
    color: var(--fabric-color-primary-50);
  }
`;

const contentStyles = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--fabric-space-gap-xs);
  flex: 1;
`;
